import { gql } from "@apollo/client";

const UPDATE_USER_TEAM = gql`
  mutation updateUserTeam(
    $teamUuid: String!
    $userUuid: String!
    $roleId: Int
    $isAdmin: Boolean
    $accountType: String
  ) {
    updateUserTeam(
      teamUuid: $teamUuid
      userUuid: $userUuid
      roleId: $roleId
      isAdmin: $isAdmin
      accountType: $accountType
    ) {
      ok
      billingImplication
    }
  }
`;

export default UPDATE_USER_TEAM;
